import React from "react";
import ShippingOne from "../components/ShippingOne";
import Checkout from "../components/Checkout";
import BreadcrumbThree from "../components/BreadcrumbThree";
import { Helmet } from "react-helmet-async";


const CheckoutPage = () => {



  return (
    <>

      <Helmet>
        <title> Checkout | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>


      {/* Breadcrumb */}
      <BreadcrumbThree title={"Checkout"} />

      {/* Checkout */}
      <Checkout />

      {/* ShippingOne */}
      <ShippingOne />


    </>
  );
};

export default CheckoutPage;
